// The vehicle GraphQL modelYears resolver rejects years before 1991.
// There is no vehicle data before this year, so the query will return a 400 for earlier years.
const MIN_GRAPHQL_MODEL_YEAR = 1991;

export function getSupportedGraphqlModelYear(year) {
  const fullYear = String(year);
  return /^\d{4}$/.test(fullYear) && Number(fullYear) >= MIN_GRAPHQL_MODEL_YEAR ? Number(fullYear) : null;
}
